module.exports = __webpack_public_path__ + "img/down.b1f10f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down.jpg
// module id = Ojxu
// module chunks = 0